export default __webpack_public_path__ + "static/media/Pistol_4.3a86fbfb.png";